import { useState, useEffect } from 'react';
import { useAuth } from 'hooks/useAuth';

export const useGlobalAlerts = () => {
  const [isExtensionInstalled, setIsExtensionInstalled] = useState(true);
  const [, forceUpdate] = useState(0);
  const { user } = useAuth();

  const checkForExtension = () => {
    const div = document.getElementById('pertento-extension-installed');
    setIsExtensionInstalled(!!div);
  };

  useEffect(() => {
    setTimeout(checkForExtension, 50);
  }, []);

  const dismiss = (what: 'Extension' | 'Passkeys') => {
    const lsKey = `PERTENTO-WARNED-${what.toUpperCase()}`;
    sessionStorage.setItem(lsKey, 'true');
    forceUpdate((n) => n + 1);
  };

  return {
    showExtensionWarning: !isExtensionInstalled && !sessionStorage.getItem('PERTENTO-WARNED-EXTENSION'),
    showPasskeysWarning: !user.passkeyCount && !sessionStorage.getItem('PERTENTO-WARNED-PASSKEYS'),
    dismiss,
  };
};
